/**
 * 灵犀打点封装
 * @param {*} $node 传入的节点
 * @param {*} valBid bid
 * @param {*} otherData 是否有额外的信息
 * @param {*} sendView 是否是发送曝光点
 * @param {*} nodeType 传入的节点是否是a标签，不是也可以发送点击点
 * @param {*} isFbLink 传入的节点是否需要自定义跳转事件
 */
const $ = require('jquery')
const lxWrap = ($node, valBid, otherData = false, sendView, nodeType = true, isFbLink) => {
    if (!window.LXAnalytics) return
    // 上报基本信息
    let valLab = {
        custom: {}
    }
    try {
        let valLabFlag = {
            click_title: 'clickTitle',
            click_name: 'clickName',
            category: 'category'
        }
        if ($node && $node.length !== 0) {
            valLab.custom.city_id = window._DP_HeaderData.cityId ? window._DP_HeaderData.cityId : 1
            valLab.custom.user_id = window._DP_HeaderData.userId ? window._DP_HeaderData.userId : null
            if (!sendView) {
                // 点击打点
                if ($node.prop('tagName').toLowerCase() === 'a' || !nodeType) {
                    // 遍历
                    $node.on('click', function(e) {
                        // 获取打点数据custom数据
                        if (otherData) {
                            for (let key in valLabFlag) {
                                if (valLabFlag.hasOwnProperty(key)) {
                                    let data = $(this).data(valLabFlag[key])
                                    if (data) {
                                        valLab.custom[key] = data
                                    }
                                }
                            }
                        }
                        window.LXAnalytics('moduleClick', valBid, valLab)
                        // 如果需要单独跳转，则延迟300ms后跳转
                        if (isFbLink) {
                            e.preventDefault()
                            let href = $(this).attr('href')
                            setTimeout(() => {
                                location.href = href
                            }, 300)
                        }
                    })
                }
            } else {
                // 曝光打点 
                $node.each(function() {
                    if (otherData) {
                        for (let key in valLabFlag) {
                            if (valLabFlag.hasOwnProperty(key)) {
                                let data = $(this).data(valLabFlag[key])
                                if (data) {
                                    valLab.custom[key] = data
                                }
                            }
                        }
                    }
                    window.LXAnalytics('moduleView', valBid, valLab)
                })
            }
        }
    } catch (e) {
        console.log('lingxi Dot Error: ' + e)
    }
}

module.exports = lxWrap



// WEBPACK FOOTER //
// ./modules/common/js/lx.js